// ========================================
// Widget: RRHH — Altas y bajas próximas
// Fechas de alta y de baja de los próximos meses (fichas del personal), marcando
// las altas que aún no se han notificado a la asesoría.
// ========================================

window.DashboardWidgets = window.DashboardWidgets || {};
window.DashboardWidgets.rrhh = window.DashboardWidgets.rrhh || {};

window.DashboardWidgets.rrhh.altasBajas = function(ctx) {
    const { moves = [] } = ctx;
    const month = iso => new Date(`${iso}T12:00:00`).toLocaleDateString('es-ES', { month: 'short' }).replace('.', '');
    const rows = moves.length ? moves.slice(0, 6).map(m => `
        <div class="rp-row" style="flex-wrap: nowrap;">
            <span class="rp-date-box ${m.kind === 'baja' ? 'is-leaving' : ''}" aria-hidden="true"><span class="rp-date-day">${m.date.slice(8, 10)}</span><span class="rp-date-month">${month(m.date)}</span></span>
            <span class="rp-row-text">
                <button type="button" class="rp-card-link rp-row-name" style="text-decoration: none; text-align: left;" ${UIEvents.attr("click", function(event,captured){App.navigate('profesor/' + String(captured[0]));}, [m.id])}>${Utils.sanitizeHTML(m.name)}</button>
                <span class="rp-row-detail ${m.advisoryPending ? 'rp-warn-text' : ''}">${m.kind === 'baja' ? 'Baja · fin de contrato' : m.freelance ? 'Alta · autónomo' : m.advisoryPending ? 'Alta · aviso a la asesoría pendiente' : 'Alta · asesoría avisada'}</span>
            </span>
        </div>`).join('') : '<div class="rp-empty">No hay altas ni bajas en los próximos meses.</div>';
    const inner = `
        <div class="rp-card-head">
            <h2 class="rp-card-title">Altas y bajas próximas</h2>
            ${moves.length > 6 ? `<button type="button" class="rp-card-link" ${UIEvents.attr("click", function(event,captured){App.navigate('profesores/altas');}, [])}>Ver todas (${moves.length})</button>` : ''}
        </div>
        <div>${rows}</div>`;
    return window.DashboardWidgets.rrhh.card(ctx, inner);
};
